module.exports = __webpack_public_path__ + "img/settings.06192d76.svg";